<script lang="ts">
import { register as decodeErrors } from '@formkit/dev'
import { checkbox, createLibraryPlugin, email, file, form, hidden, number, select, text, textarea, url } from '@formkit/inputs'
import { accepted, email as emailValidation, length, required } from '@formkit/rules'
import { createValidationPlugin } from '@formkit/validation'
import { bindings, FormKitProvider } from '@formkit/vue'
import { defineComponent } from 'vue'

decodeErrors()

const library = createLibraryPlugin({ checkbox, email, url, file, number, form, hidden, text, textarea, select })
const validation = createValidationPlugin({ accepted, email: emailValidation, required, length })

const legends = ['checkbox_multi', 'radio_multi', 'repeater', 'transferlist']
const customizeInputSchema = function (node) {
  if (['button', 'submit', 'hidden', 'group', 'list', 'meta'].includes(node.props.type)) return
  const legendOrLabel = legends.includes(node.props.type) ? 'legend' : 'label'
  const schemaFn = node.props.definition.schema
  if (node.props.definition.schemaMemoKey) {
    node.props.definition.schemaMemoKey += 'add_astrisks'
  }
  node.props.definition.schema = (sectionsSchema = {}) => {
    sectionsSchema[legendOrLabel] = {
      children: ['$label', {
        $el: 'span',
        if: '$state.required',
        attrs: {
          class: '$classes.asterisk'
        },
        children: ['*']
      }]
    }
    // @ts-ignore
    sectionsSchema.messages = { if: 'true' }

    return schemaFn(sectionsSchema)
  }
}

const config = {
  plugins: [bindings, library, validation, customizeInputSchema]
}

export default defineComponent({
  name: 'FormProvider',
  components: {
    FormKitProvider
  },
  setup () {
    return {
      config
    }
  }
})
</script>

<template>
  <FormKitProvider :config="config">
    <slot />
  </FormKitProvider>
</template>
